import type { OutcomeStats } from "~/features/orders/types";

const outcomeClassMap: Record<string, string> = {
  answered: 'badge outcome-confirmed',
  rescheduled: 'badge outcome-reschedule',
  alternate_window: 'badge outcome-alt',
  confirmed_with_voicemail: 'badge outcome-confirmed',
  confirmed_with_no_answer: 'badge outcome-confirmed',
  confirmed_through_transfer: 'badge outcome-transfer',
  incorrect_phone_number: 'badge outcome-invalid',
  cancelled: 'badge outcome-cancelled',
  unanswered: 'badge outcome-noanswer',
  // Legacy mappings for backward compatibility
  confirmed: 'badge outcome-confirmed',
  alt_window: 'badge outcome-alt',
  reschedule: 'badge outcome-reschedule',
  no_answer: 'badge outcome-noanswer',
  transfer: 'badge outcome-transfer',
  invalid_number: 'badge outcome-invalid',
};

export const outcomeLabelMap: Record<string, string> = {
  answered: 'Answered',
  rescheduled: 'Rescheduled',
  alternate_window: 'Alternate window',
  confirmed_with_voicemail: 'Confirmed with Voicemail',
  confirmed_with_no_answer: 'Confirmed with No answer',
  confirmed_through_transfer: 'Confirmed through Transfer',
  incorrect_phone_number: 'Incorrect phone number',
  cancelled: 'Cancelled',
  unanswered: 'Unanswered',
  // Legacy mappings for backward compatibility
  confirmed: 'Confirmed',
  alt_window: 'Alternate window',
  reschedule: 'Rescheduled',
  no_answer: 'No Answer',
  transfer: 'Transfer',
  invalid_number: 'Invalid Number',
};

/** User-friendly label for outcome values. Use in filter dropdowns and anywhere raw outcome is shown. */
export function getOutcomeLabel(outcome: string): string {
  if (outcome == null || String(outcome).trim() === '') return '—';
  const key = String(outcome).toLowerCase();
  return outcomeLabelMap[key] ?? outcome.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function OutcomeBadge({ outcome }: { outcome?: string }) {
  if (!outcome) return <span className="badge neutral">Pending</span>;
  const key = outcome.toLowerCase();
  const cls = outcomeClassMap[key] ?? 'badge neutral';
  const label = outcomeLabelMap[key] ?? outcome.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  return <span className={cls}>{label}</span>;
}
